__turbopack_context__.v({
  "loader": "ModalMenuRoutes-module-scss-module__AVCIpa__loader",
  "loaderWrapper": "ModalMenuRoutes-module-scss-module__AVCIpa__loaderWrapper",
  "modalMenuRoutes": "ModalMenuRoutes-module-scss-module__AVCIpa__modalMenuRoutes",
  "modalMenuRoutes__active": "ModalMenuRoutes-module-scss-module__AVCIpa__modalMenuRoutes__active",
  "modalMenuRoutes__box": "ModalMenuRoutes-module-scss-module__AVCIpa__modalMenuRoutes__box",
  "modalMenuRoutes__route": "ModalMenuRoutes-module-scss-module__AVCIpa__modalMenuRoutes__route",
});
